module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/login/adm.component.scss
// module id = ./src/app/login/adm.component.scss
// module chunks = main